// extracted by mini-css-extract-plugin
module.exports = {"main_sec":"style_main_sec__1C3XZ","right":"style_right__28z1b","inner":"style_inner__3ZXl0","main-img":"style_main-img__1zWET","left":"style_left__nQ_kt"};